<script setup lang="ts">
import { StaticPage } from "~/pages/static";
</script>
<template>
  <StaticPage />
</template>
